<button class="flex items-center gap-1" type="button" (click)="onSortClick()">
  <span [appPopover]="titleTooltip() ?? ''">{{ title() }}</span>

  <div class="flex items-center w-3 h-3">
    @if (sortDirection(); as sortDirection) {
      <svg-icon size="12" [key]="sortDirection === SortDirectionStoreModelEnum.Asc ? 'icon-arrow-up-12' : 'icon-arrow-down-12'"></svg-icon>
    }
  </div>
</button>
